module.exports = __webpack_public_path__ + "static/media/0012.d6f23a4a.svg";